module.exports = __webpack_public_path__ + "img/banner-imatters.cc94e41c.jpg";